import { useEffect } from "react";

import { withMixpanel } from "@application/initializers/mixpanel";

export const useTrackPageView = ({ page }: { page: string }) => {
  useEffect(() => {
    withMixpanel((mixpanel) => mixpanel.track_pageview({ page }));
  }, [page]);
};
